import React, { useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { IConfirmPurchaseLeadsModalProps } from '@mm/state/modules/modalsState/props';
import { CloseModalProps } from '../../../../../../../common/modals/modal-helpers';
import { PrimaryButton } from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import styles from './ConfirmPurchaseLeadsModal.module.css';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import {
  selectFreezedCreditsSum,
  selectPurchasableLeadsCount,
} from '@mm/state/selectors/leadsSearchSelectors';
import { useSelector } from 'react-redux';
import { selectActiveFacebookPage } from '@mm/state/selectors/facebookPageSelector';
import classNames from 'classnames';
import {
  LEAD_COST_IN_CREDITS,
  MAX_CONTACTS_ALLOWED,
} from '../PurchaseContactsTable';
import { abbreviateNumber } from '@mm/utils';

export const ConfirmPurchaseLeadsModal = ({
  onConfirm,
  params,
}: IConfirmPurchaseLeadsModalProps & CloseModalProps) => {
  const { closeModal } = useModalActions();
  const filteredLeadsCount = useSelector(selectPurchasableLeadsCount);
  const facebookPage = useSelector(selectActiveFacebookPage);
  const freezedCreditsSum = useSelector(selectFreezedCreditsSum);
  const leadsCountGreater10K =
    filteredLeadsCount?.relation === 'gte' && params.searchBody?.query.length;
  const [busy, setBusy] = useState(false);

  const onConfirmClick = async () => {
    setBusy(true);
    await onConfirm();
    setBusy(false);
  };

  const purchaseLeadsCount =
    Number(
      params.leadIds?.length
        ? params.leadIds?.length
        : params?.searchBody?.limit
        ? params?.searchBody?.limit
        : leadsCountGreater10K
        ? MAX_CONTACTS_ALLOWED
        : filteredLeadsCount?.value,
    ) - Number(params.excludedLeadIds?.length || 0);

  const creditsAvailable = Math.floor(
    Number(facebookPage?.outgoingMessagesLimit) -
      Number(facebookPage?.outgoingMessageUsage?.subscriptionMessagingCount) -
      freezedCreditsSum,
  );

  const totalCostInCretits =
    (purchaseLeadsCount || MAX_CONTACTS_ALLOWED) * LEAD_COST_IN_CREDITS;

  return (
    <div className={styles.container}>
      <CloseOutlined
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />

      <div className={styles.header}>
        <div className={styles.title}>
          You are about to purchase{' '}
          {purchaseLeadsCount?.toLocaleString('en-US')} leads
          <div className={styles.subtitle}>
            This will use {abbreviateNumber(totalCostInCretits)} credits of your
            total {abbreviateNumber(creditsAvailable)} credits available
          </div>
        </div>
      </div>
      {(purchaseLeadsCount || 0) >= MAX_CONTACTS_ALLOWED && (
        <div className={styles.content}>
          We have a limit to sell 10K leads at once. Don’t worry! You can buy
          more leads right after this purchase.
        </div>
      )}
      <div
        className={classNames(styles.content, {
          [styles.textCentered]: !leadsCountGreater10K,
        })}
      >
        {' '}
        These leads will be added to your “My Leads” dashboard where you can add
        them to your outreach automation, export, or filter.
      </div>
      <PrimaryButton
        onClick={onConfirmClick}
        className={styles.primaryBtn}
        disabled={busy}
      >
        Purchase
      </PrimaryButton>
    </div>
  );
};
